
import React, { useState, useCallback, useMemo } from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import Home from './pages/Home';
import Shop from './pages/Shop';
import Collections from './pages/Collections'; // Nueva importación
import ProductDetail from './pages/ProductDetail';
import Checkout from './pages/Checkout';
import Contact from './pages/Contact';
import About from './pages/About';
import CustomDesign from './pages/CustomDesign';
import Success from './pages/Success';      
import Cancel from './pages/Cancel';        
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import PageMeta from './components/PageMeta';
import AvisoLegal from './pages/AvisoLegal';
import Privacidad from './pages/Privacidad';
import Cookies from './pages/Cookies';
import Terminos from './pages/Terminos';
import EnviosDevoluciones from './pages/EnviosDev';
import { useEffect } from 'react';

import { CartItem, Product } from './types';

const App: React.FC = () => {
  const [cart, setCart] = useState<CartItem[]>(() => {
    try {
      const saved = localStorage.getItem('sanan_cart');
      return saved ? JSON.parse(saved) : [];
    } catch (e) {
      console.error("Error leyendo carrito de localStorage", e);
      return [];
    }
  });
  
  useEffect(() => {
    localStorage.setItem('sanan_cart', JSON.stringify(cart));
  }, [cart]);


  const addToCart = useCallback((item: CartItem) => {
    setCart(prev => {
      const existing = prev.find(i => 
        i.product.id === item.product.id && 
        i.size === item.size && 
        i.color === item.color
      );
      if (existing) {
        return prev.map(i => 
          i === existing ? { ...i, quantity: i.quantity + item.quantity } : i
        );
      }
      return [...prev, item];
    });
  }, []);

  const removeFromCart = useCallback((productId: string, size: string, color: string) => {
    setCart(prev => prev.filter(i => 
      !(i.product.id === productId && i.size === size && i.color === color)
    ));
  }, []);

  const updateQuantity = useCallback((productId: string, size: string, color: string, quantity: number) => {
    setCart(prev => prev.map(i => 
      (i.product.id === productId && i.size === size && i.color === color)
        ? { ...i, quantity: Math.max(1, quantity) }
        : i
    ));
  }, []);

  const clearCart = useCallback(() => {
  setCart([]);
  localStorage.removeItem('sanan_cart');
}, []);

  return (
    <Router>
      <ScrollToTop />
      <PageMeta />
      <div className="flex flex-col min-h-screen">
        <Navbar cartCount={cart.reduce((sum, i) => sum + i.quantity, 0)} />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/shop" element={<Shop />} />
            <Route path="/collections" element={<Collections />} />
            <Route path="/product/:id" element={<ProductDetail onAddToCart={addToCart} />} />
            <Route path="/checkout" element={<Checkout cart={cart} removeFromCart={removeFromCart} updateQuantity={updateQuantity} />} />
            <Route path="/custom" element={<CustomDesign onAddToCart={addToCart} />} />
	    <Route path="/success" element={<Success clearCart={clearCart} />} />
	    <Route path="/cancel" element={<Cancel />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/about" element={<About />} />

<Route path="/aviso-legal" element={<AvisoLegal />} />
<Route path="/privacidad" element={<Privacidad />} />
<Route path="/cookies" element={<Cookies />} />
<Route path="/terminos" element={<Terminos />} />
<Route path="/envios-devoluciones" element={<EnviosDevoluciones />} />
          </Routes>
        </main>
        <Footer />
{/* BOTÓN FLOTANTE DE WHATSAPP */}
<a 
  href="https://wa.me/34614409356" 
  target="_blank" 
  rel="noopener noreferrer"
  className="fixed bottom-6 right-6 z-[55] flex items-center justify-center hover:scale-110 transition-transform active:scale-95 group"
  aria-label="Contactar por WhatsApp"
>
  <img
    src="/whats.png"
    alt="WhatsApp"
    className="size-14 md:size-15 drop-shadow-2xl"
  />

  <span className="absolute right-full mr-4 bg-white text-black text-[10px] font-black uppercase tracking-widest px-3 py-1.5 rounded-lg opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap border border-gray-100 shadow-sm pointer-events-none italic">
    ¿Necesitas ayuda?
  </span>
</a>
      </div>
    </Router>
  );
};

export default App;
